/*LIBRARY*/
import { useState, useEffect, useCallback } from "react";
import { FileUploader } from "react-drag-drop-files";
import "handsontable/dist/handsontable.full.min.css";
import { registerAllModules } from "handsontable/registry";
import { connect } from "react-redux";
import { CircularProgress } from "@mui/material";

/*COMPONENT*/
import SheetButton from "./SheetButton";
import Modal from "../common_modal/Modal";
import EXCEL_HBU from "./EXCEL_HBU";
import HotTableWrapper from "./HotTableWrapper";
import PANGGIL_MENU from "./PANGGIL_MENU";
import EXCEL_APPRAISAL from "./EXCEL_APPRAISAL";

/*REDUX*/
import { snackbar } from "../../App/actions/snackbarActions";
import {
  set_sheet_value,
  get_sheets_by_cell,
} from "../../App/actions/sheetAction";

/*PICTURE*/

/*FUNCTION*/
import { getFeatureByKey, getGeoLayer } from "../../App/reduxHelper/layer";
import { convertGeoJsonToSheetPembanding } from "../../App/validation/kai_appraisal_function";
import { get_data_pembanding } from "../../App/actions/generate_ai_appraisal_summary";
import { convertExcelDataToHandsontableFormatArray } from "../../App/validation/convert_data";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
registerAllModules();

const SelectTableContent = (props) => {
  const {
    hotTableRef,
    handleKeyDown,
    worksheet,
    setWorksheet,
    setRawSheets,
    rawSheets,
    hyperformulaInstance,
    geo_layer_id,
    feature_key,
    field_key,
    latitude,
    longitude,
    get_data_pembanding,
    set_sheet_value,
    get_sheets_by_cell,
    define_need_to_show,
    selectedCell,
    uploaded_file,
    focused,
    selectedSheet,
    sheetnames,
    setSheetnames,
    setSelectedSheet,
    handleRefCol,
    // handle_selected_cell,
    // setFocused,
    // handle_edit_cell,
    // hotTableRef,
    // isDeleting,
    column_type,
    cloneTemplate,
    is_loading_clone,
    // hyperformulaInstance
    calculatedSheets,
    snackbar,
  } = props;

  const [modal_ai, set_modal_ai] = useState(false);

  const toggle_ai = useCallback(() => {
    set_modal_ai((prev) => !prev);
  }, []);

  useEffect(() => {
    const hotInstance = hotTableRef?.current?.hotInstance;

    // Tambahkan hook `beforeKeyDown` untuk menangkap shortcut
    if (hotInstance) hotInstance?.addHook("beforeKeyDown", handleKeyDown);

    return () => {
      // Hapus hook untuk menghindari kebocoran event listener
      if (hotInstance) hotInstance?.removeHook("beforeKeyDown", handleKeyDown);
    };
  }, [hotTableRef, handleKeyDown]);

  // componentDidMount() {
  //   const { hotTableRef, handleKeyDown } = this.props;
  //   const hotInstance = hotTableRef?.current?.hotInstance;

  //   // Tambahkan hook `beforeKeyDown` untuk menangkap shortcut
  //   if (hotInstance) hotInstance?.addHook("beforeKeyDown", handleKeyDown);

  //   const {
  //     worksheet,
  //     setCalculatedSheets
  //   } = this.props;

  //   const data = convertExcelDataToHandsontableFormatArray(worksheet);

  //   this.hyperformulaInstance = HyperFormula.buildFromSheets(data, hyperformulaConfigInput);
  //   const calculatedSheeData = this.hyperformulaInstance.getAllSheetsValues();
  //   setCalculatedSheets(calculatedSheeData);
  // }

  // handleBeforeKeyDown = (event) => {
  //   const { hotTableRef, handleKeyDown } = this.props;
  //   const hotInstance = hotTableRef?.current?.hotInstance;
  //   const activeEditor = hotInstance?.getActiveEditor();

  //   if (activeEditor) {

  //     // const editorElement = activeEditor?.getElement();
  //     // const currentValue = editorElement?.value;

  //     // // Manipulasi atau ubah nilai di sini
  //     // if (event.key === "Enter") {
  //     //   // Misalnya, ganti nilai menjadi "Hello World" saat tekan Enter
  //     //   editorElement.value = "Hello World";
  //     // }
  //   }
  // };

  const get_kebutuhan_data_pembanding = useCallback((worksheet_data) => {
    const nam_data_pembanding = [
      "Data Pembanding 1",
      "Data Pembanding 2",
      "Data Pembanding 3",
    ];
    let sheetIndexDataObject = -1;
    let sheetIndexDataPembanding = [];

    for (const [index, sheet] of (worksheet_data || []).entries()) {
      if (sheet?.metadata?.id_ori === "Data Objek") {
        sheetIndexDataObject = index;
      } else if (nam_data_pembanding.includes(sheet?.metadata?.id_ori)) {
        sheetIndexDataPembanding.push(index);
      }
    }

    let tipeProperti = "";
    let luasTanah = 0;
    let tahunDibangun = 0;

    worksheet_data?.[sheetIndexDataObject]?.value?.forEach((item) => {
      if (item?.p === "E6") {
        tipeProperti = item?.v;
      } else if (item?.p === "E10") {
        luasTanah = item?.v;
      } else if (item?.p === "E26") {
        tahunDibangun = item?.v;
      }
    });

    return {
      tipeProperti,
      luasTanah,
      tahunDibangun,
      sheetIndexDataObject,
      sheetIndexDataPembanding,
    };
  }, []);

  const handle_get_data_pembanding = useCallback(async () => {
    // perlu dihapus
    const development_worksheet = worksheet;
    let local_worksheet = JSON.parse(JSON.stringify(development_worksheet));

    const parameter_data_pembanding =
      get_kebutuhan_data_pembanding(local_worksheet);
    const { sheetIndexDataPembanding } = parameter_data_pembanding;

    const body = {
      latitude,
      longitude,
      ...parameter_data_pembanding, //tipeProperti, luasTanah, tahunDibangun
    };

    let res_data_pembanding = await get_data_pembanding(body);

    if (res_data_pembanding?.status === 200) {
      if (res_data_pembanding?.data?.length > 0) {
        res_data_pembanding = res_data_pembanding?.data.map((item, index) => {
          const index_for_worksheet = sheetIndexDataPembanding?.[index];
          const sheet_id = local_worksheet?.[index_for_worksheet]?._id;
          return {
            ...item,
            _id: sheet_id,
          };
        });

        const sheet_data_pembanding = convertGeoJsonToSheetPembanding({
          features: res_data_pembanding,
          geo_layer_id,
          feature_key,
          field_key,
        });

        for (const [
          index_for_dataPembanding,
          index_for_worksheet,
        ] of sheetIndexDataPembanding.entries()) {
          if (sheet_data_pembanding?.[index_for_dataPembanding]) {
            local_worksheet[index_for_worksheet] =
              sheet_data_pembanding?.[index_for_dataPembanding];
            if (
              sheet_data_pembanding?.[index_for_dataPembanding]?.value?.length >
              0
            ) {
              await set_sheet_value({
                sheet_id: local_worksheet?.[index_for_worksheet]?._id, //template
                value: sheet_data_pembanding?.[index_for_dataPembanding]?.value,
              });
            }
          }
        }

        const body_sheets = {
          geo_layer_id,
          feature_key,
          field_key,
        };

        const data = await get_sheets_by_cell(body_sheets);
        const sheetData = convertExcelDataToHandsontableFormatArray(data);
        if (hyperformulaInstance) {
          Object.keys(rawSheets).forEach((sheetName) => {
            const sheet_id = hyperformulaInstance.getSheetId(sheetName);
            if (sheet_id)
              hyperformulaInstance.setSheetContent(
                sheet_id,
                sheetData[sheetName],
              );
          });
        }

        setRawSheets(sheetData);
        setWorksheet(data?.length > 0 ? data : null);
      }
    }
  }, [
    worksheet,
    get_kebutuhan_data_pembanding,
    latitude,
    longitude,
    get_data_pembanding,
    geo_layer_id,
    feature_key,
    field_key,
    set_sheet_value,
    get_sheets_by_cell,
    hyperformulaInstance,
    rawSheets,
    setRawSheets,
    setWorksheet,
  ]);

  const language = localStorage?.language || "ina";

  // const sheet =
  //   worksheet?.find((obj) => obj?.metadata?.id_ori === selectedSheet) || {};
  // const is_mobile = window.innerWidth < 600;

  // const domain = auth.domain;
  // const is_domain_kai = domain_list?.[domain]?.is_domain_kai;

  let textfield = "";
  if (selectedCell?.f) {
    textfield = `=${selectedCell?.f}`;
  } else if (selectedCell?.R) {
    const { sheet_id, cell_ref } = selectedCell?.R;
    textfield = `@ref?id=${sheet_id}&cell=${cell_ref}`;
  } else {
    textfield = selectedCell?.v || "";
  }

  // const { data, columns } = convertExcelDataToHandsontableFormat({
  //   sheet,
  //   selectedSheet,
  //   rawData: worksheet,
  // });

  let summary_content = null;
  if (column_type === "sheet_hbu") {
    summary_content = (
      <EXCEL_HBU
        hyperformulaInstance={hyperformulaInstance}
        setWorksheet={setWorksheet}
        setRawSheets={setRawSheets}
        rawSheets={rawSheets}
        dbWorksheet={worksheet}
        worksheet={calculatedSheets}
        geo_layer_id={geo_layer_id}
        feature_key={feature_key}
        field_key={field_key}
      />
    );
  } else {
    summary_content = (
      <EXCEL_APPRAISAL
        worksheet={calculatedSheets}
        geo_layer_id={geo_layer_id}
        feature_key={feature_key}
        field_key={field_key}
      />
    );
  }

  const modal_ai_content = modal_ai && (
    <Modal
      title="AI Excel"
      id="modal_ai_content"
      modalSize="full"
      is_hide="show"
      backgroundColor="rgba(255, 255, 255, 1);"
      use_blur={false}
      blur_value="5px"
      borderRadius="5px"
      isOpen={modal_ai}
      onClose={toggle_ai}
    >
      <div className="box-body" id="box-body" style={{ overflow: "hidden" }}>
        {summary_content}
      </div>
    </Modal>
  );

  let content_button_clone = null;
  if (is_loading_clone) {
    content_button_clone = <CircularProgress />;
  } else {
    if (column_type === "sheet_hbu") {
      content_button_clone = (
        <>
          {["HBU Tanah Kosong", "HBU Terbangun"].map((key, idx) => (
            <button
              key={idx}
              className="button bg_blue text_white h_30 hover_bigger marginRight_20 marginTop_10"
              onClick={async () => {
                cloneTemplate(key);
                toggle_ai();
              }}
            >
              {`Use ${key}`}
            </button>
          ))}
        </>
      );
    } else {
      content_button_clone = (
        <button
          className="button bg_blue text_white h_30 hover_bigger marginRight_20 marginTop_10"
          onClick={async () => {
            cloneTemplate();
            toggle_ai();
          }}
        >
          {`Use Appraisal`}
        </button>
      );
    }
  }

  const button_use_template = (
    <div className="h_full center_right">{content_button_clone}</div>
  );

  const is_use_template = ["sheet_hbu", "sheet_appraisal"].includes(
    column_type,
  );
  const is_button_use_template_showing = is_use_template && !worksheet;

  return (
    <main>
      {modal_ai_content}
      {!worksheet && (
        // '(!["hbu", "appraisal"].includes(from)) &&
        <div>
          {is_button_use_template_showing && button_use_template}
          <label>Upload your Sheet (.xlsx)</label>
          <div className="border_dash">
            <FileUploader
              classes="container_upload absolute h_full pointer"
              handleChange={(e) => {
                define_need_to_show(e);
              }}
              name="file"
              types={["xlsx"]}
              onTypeError={(e) => {
                snackbar({
                  is_open: true,
                  status: "error",
                  message: e,
                });
              }}
              children={
                <div className="container_upload center_perfect">
                  <div>
                    {uploaded_file?.fileName ||
                      `${dict["Drop a file here"][language]}`}
                  </div>
                </div>
              }
            />
          </div>
        </div>
      )}

      {/* {
            worksheet && <Button onClick={() => this.on_dowload_json()}>
              Download
            </Button>
          } */}
      {/* {
          column_type === "sheet_appraisal" && worksheet && <button className="button bg_blue" onClick={() => { this.handle_generate_data_objek() }}>
            Generate data objek (development only)
          </button>
        } */}

      {column_type === "sheet_appraisal" && worksheet && (
        <button
          className="button bg_blue"
          onClick={() => {
            handle_get_data_pembanding();
          }}
        >
          Generate Data Pembanding
        </button>
      )}

      {worksheet && (
        <section>
          <div className="flex gap_10">
            <input
              type="text"
              value={textfield}
              disabled
              style={{
                width: "100%",
                marginBottom: "10px",
                padding: "8px",
                fontSize: "16px",
                display: "inline-block",
              }}
            />

            <PANGGIL_MENU handleRefCol={handleRefCol} focused={focused} />

            {/* {focused ? (
                <Button
                  id="ref_button"
                  onClick={handleRefCol}
                  style={{ height: "40px" }}
                  variant="outlined"
                >
                  Ref
                </Button>
              ) : (
                <Button
                  id="ref_button"
                  onClick={handleRefCol}
                  style={{ height: "40px" }}
                  variant="outlined"
                  disabled={true}
                >
                  Ref
                </Button> 
              )}*/}
            {is_use_template && (
              <button
                id="chat_ai"
                onClick={toggle_ai}
                style={{ height: "40px", width: "200px" }}
                className="button_big background_black"
              >
                {`${dict["Summary"][language]} ${
                  column_type === "sheet_hbu" ? "HBU" : "Appraisal"
                }`}
              </button>
            )}
          </div>

          {/* <Spreadsheet /> */}

          <HotTableWrapper
            setSelectedSheet={setSelectedSheet}
            selectedSheet={selectedSheet}
            textfield={textfield}
            {...props}
          />

          {worksheet && (
            <div className="w_full scroll_x_auto">
              <div className="w_full flex_row flex align_center no_wrap gap_10 h_50">
                <label>Sheet:</label>
                {sheetnames?.map((item) => (
                  <SheetButton
                    key={item?.id_ori}
                    sheetname={item}
                    selectedSheet={selectedSheet}
                    sheetnames={sheetnames}
                    setSheetnames={setSheetnames}
                    setSelectedSheet={setSelectedSheet}
                    setWorksheet={setWorksheet}
                    worksheet={worksheet}
                  />
                ))}
              </div>
            </div>
          )}
        </section>
      )}
    </main>
  );
};

const mapStateToProps = (state, props) => {
  const geo_layer = getGeoLayer(state.layer);
  const feature = getFeatureByKey({
    geo_layer,
    feature_key: props.feature_key,
  });
  const coordinates = feature?.geometry?.coordinates || [];
  const [longitude, latitude] = coordinates;

  return {
    longitude,
    latitude,
    geo_layer_id: geo_layer?._id,
  };
};

export default connect(mapStateToProps, {
  snackbar,
  get_data_pembanding,
  set_sheet_value,
  get_sheets_by_cell,
})(SelectTableContent);
